<div class="generic-modal-root">

  <ngx-loading [show]="loading"></ngx-loading>

  <div>
      <div class="row" style="padding-left: 10px">
          <table class="row-padding">  
              <tr style="padding-left: 10px">         
                <td>
                  <span>Purchase Name</span>
                </td>
                <td style="padding-left: 10px"> 
                  {{purchase.description}}
                </td>
              </tr>
  
              <tr>          
                  <td>
                     <span>Date Purchased</span>
                  </td>
                  <td style="padding-left: 10px">
                      {{purchase.datePurchased | date:'MM-dd-yyyy hh:mm a z'}}
                  </td>
                </tr>
  
              <tr>         
                  <td>
                    <span>Purchased By</span>
                  </td>
                  <td style="padding-left: 10px">
                      {{purchase.userEmail}}
                  </td>
              </tr>
              <tr>         
                <td>
                  <span>Total Amount / Total Tax</span>
                </td>
                <td style="padding-left: 10px">
                    ${{purchase.totalAmount | number : '1.2-2'}} / ${{purchase.totalTax | number : '1.2-2'}}
                </td>
              </tr>
              <tr *ngIf="purchase.couponValid">         
                <td>
                  <span>Amount Off</span>
                </td>
                <td style="padding-left: 10px">
                    ${{purchase.amountOff | number : '1.2-2'}}
                </td>
            </tr>
              <tr>         
                <td>
                  <span>Complete</span>
                </td>
                <td style="padding-left: 10px">
                    {{purchase.purchaseComplete ? "True" : "False"}} 
                </td>
              </tr>
              <tr>         
                  <td>
                    <span>Coupon Code / Valid</span>
                  </td>
                  <td style="padding-left: 10px">
                      {{purchase.couponCode ? purchase.couponCode : "N/A"}} / {{purchase.couponValid ? "True" : "False"}} 
                  </td>
              </tr>
              <tr>         
                  <td>
                    <span>Stripe Token</span>
                  </td>
                  <td style="padding-left: 10px">
                      {{purchase.stripeToken}} 
                  </td>
              </tr>             
        </table>
      </div>

    <span class="row" style="padding-left: 10px">Purchase Details</span>    
    <div class="row" style="padding-left: 10px" *ngFor="let detail of purchaseDetails">
        <table class="row-padding">  
            <tr style="padding-left: 10px">         
              <td>
                <span>Product Name</span>
              </td>
              <td style="padding-left: 10px"> 
                {{detail.productName}}
              </td>
            </tr>

            <tr>          
                <td>
                   <span>Amount</span>
                </td>
                <td style="padding-left: 10px">
                  {{detail.amount}}
                </td>
              </tr>

            <tr>         
                <td>
                  <span>Tax</span>
                </td>

                <td style="padding-left: 10px">
                  {{detail.tax}}
                </td>
            </tr>
            <tr>         
              <td>
                <span>Quantity</span>
              </td>

              <td style="padding-left: 10px">
                {{detail.quantity}}
              </td>
          </tr>
              
      </table>
    </div>
  </div>

  <div class="row">
    <button (click)="close()" class="btn btn-success" style="margin:10px; float:right">Cancel</button>
  </div>
</div>